import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  props: {
    initOperateData: {
      type: Object,
      default: () => {}
    },
    mainWindowType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      resolutionOptions: [{
        value: '160x90',
        label: '160x90'
      }, {
        value: '320x180',
        label: '320x180'
      }, {
        value: '480x270',
        label: '480x270'
      }, {
        value: '640x360',
        label: '640x360'
      }, {
        value: '848x480',
        label: '848x480'
      }, {
        value: '1280x720',
        label: '1280x720'
      }, {
        value: '1920x1080',
        label: '1920x1080'
      }],
      value: '1280x720',
      ratesOptions: [{
        value: '15',
        label: '15'
      }, {
        value: '30',
        label: '30 (default)'
      }, {
        value: '60',
        label: '60'
      }],
      deviceLeaveRules: [{
        label: 'immediately',
        value: 'immediately'
      }, {
        label: 'oneHour',
        value: 'oneHour'
      }, {
        label: 'twoHour',
        value: 'twoHour'
      }, {
        label: 'twentyFourHour',
        value: 'twentyFourHour'
      }, {
        label: 'customize',
        value: 'customize'
      }],
      deviceLeaveHour: 'immediately',
      ratesValue: '30',
      mainWindowBitrate: 400,
      inputBitrateValue: 400,
      mainWindowVolume: 100,
      pipVolume: 100,
      inputPipVolume: 100,
      inputVolume: 100,
      disabledMainWindowVolume: 100,
      disabledInputVolume: 100,
      gotPopperVal: false
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      partyCode: state => state.partyCode
    }),
    calMaxBitrate() {
      let maxBitrate = 5000;
      if (this.value === '1920x1080') {
        // 将1080p大于30fps的比特率上限设置为4Mbps
        maxBitrate = 4000;
      } else if (this.value === '1280x720') {
        // 对720p的任何帧率，将比特率上限设置为5Mbps
        maxBitrate = 5000;
      }
      return maxBitrate;
    }
  },
  created() {
    Bus.$on('initMainWindow', () => {
      this.initMainWindow();
    });
  },
  watch: {
    'initOperateData.vfbResolution': {
      handler: function (newValue) {
        if (newValue) {
          this.value = newValue;
        } else {
          this.value = '1280x720';
        }
      },
      immediate: true
    },
    'initOperateData.vfbFrameRate': {
      handler: function (newValue) {
        if (newValue) {
          this.ratesValue = newValue;
        } else {
          this.ratesValue = '30';
        }
      },
      immediate: true
    },
    'initOperateData.vfbBitrate': {
      handler: function (newValue) {
        if (newValue) {
          this.mainWindowBitrate = newValue;
        } else {
          this.mainWindowBitrate = 400;
        }
      },
      immediate: true
    },
    'initOperateData.volume': {
      handler: function (newValue, oldValue) {
        if (newValue || newValue == 0) {
          this.mainWindowVolume = newValue;
          if (this.mainWindowType === 'shareScreen') {
            this.disabledMainWindowVolume = newValue;
          }
        } else {
          this.mainWindowVolume = 100;
        }
      },
      immediate: true
    },
    'initOperateData.pipVolume': {
      handler: function (newValue, oldValue) {
        if (newValue || newValue == 0) {
          this.pipVolume = newValue;
        } else {
          this.pipVolume = 100;
        }
      },
      immediate: true
    }
  },
  methods: {
    validateFrameRate(resolution, rate) {
      if (resolution === '1920x1080' && rate > 30) {
        return true; // 禁用1080p 分辨率大于30fps的帧率
      }

      return false;
    },
    // 分辨率+帧率联动码率
    updateBitrate() {
      const bitrates = new Map([['160x90-15', 100], ['160x90-30', 100], ['160x90-60', 100], ['320x180-15', 200], ['320x180-30', 200], ['320x180-60', 200], ['480x270-15', 400], ['480x270-30', 400], ['480x270-60', 400], ['640x360-15', 800], ['640x360-30', 800], ['640x360-60', 1000], ['848x480-15', 610], ['848x480-30', 930], ['848x480-60', 930], ['1280x720-15', 1130], ['1280x720-30', 2000], ['1280x720-60', 3000], ['1920x1080-15', 2080], ['1920x1080-30', 3150], ['1920x1080-60', 4780]]);
      if (this.value == '1920x1080' && this.ratesValue == '60') {
        this.ratesValue = '30';
      }
      const key = `${this.value}-${this.ratesValue}`;
      this.mainWindowBitrate = bitrates.get(key);
    },
    changeBirateVal(value) {
      value = Number(value);
      if (isNaN(value)) {
        this.$message.warning(this.$t('partyInfo.inputNumber'));
        return;
      }
      if (value > 5000 || value < 200) {
        if (value > 5000) {
          this.inputBitrateValue = 5000;
          this.mainWindowBitrate = 5000;
        } else {
          this.inputBitrateValue = 200;
          this.mainWindowBitrate = 200;
        }
        this.$message.error(this.$t('setting.bitrateMessage'));
      } else {
        this.mainWindowBitrate = value;
      }
    },
    changeVolume(value) {
      value = Number(value);
      this.mainWindowVolume = value;
      if (value > 100) {
        this.$message.error(this.$t('setting.minVolumeMessage'));
      }
    },
    changePipVolume(value) {
      value = Number(value);
      this.pipVolume = value;
      if (value > 100) {
        this.$message.error(this.$t('setting.minVolumeMessage'));
      }
    },
    changeBitrateInputValue(value) {
      this.inputBitrateValue = value;
    },
    submitSetting() {
      this.gotPopperVal = false;
      let volume = this.mainWindowVolume;
      if (this.mainWindowType === 'shareScreen') {
        volume = this.disabledMainWindowVolume;
      }
      if (this.$route.name == 'globalControl') {
        const params = {
          frameRate: Number(this.ratesValue),
          bitrate: this.mainWindowBitrate + 'K',
          resolution: this.value,
          volume: volume,
          globalControlId: this.State.globalControlId
        };
        this.axios.post('/partyline-backend/globalControl/mainWindow', params).then(res => {
          if (res.data.errorCode === '0x0') {
            this.$emit('callback');
            this.$message.success(this.$t('setting.mainWindowSaveMessage'));
          }
        });
      } else {
        const params = {
          frameRate: Number(this.ratesValue),
          bitrate: this.mainWindowBitrate + 'K',
          resolution: this.value,
          volume: volume,
          pipVolume: this.pipVolume
        };
        this.axios.post(`/partyline-backend/partyAction/mainWindowSetting?partyCode=${this.partyCode}&key=58424`, params, {
          errorTip: false
        }).then(res => {
          if (res.data.errorCode == '0x0' || res.data.errorCode == '81000007') {
            this.$message.success(this.$t('setting.mainWindowSaveMessage'));
            const mainWidowObj = {
              vfbResolution: this.value,
              vfbFrameRate: this.ratesValue,
              vfbBitrate: this.mainWindowBitrate,
              volume: this.mainWindowVolume,
              pipVolume: this.pipVolume
            };
            this.$emit('changeButtonFlag', mainWidowObj, 'mainWindow');
          } else {
            this.$message.success(res.data.errorInfo);
          }
          if (this.State.pgmStream) this.hasChangeInfo = true;
          this.$emit('callback');
        });
      }
    },
    changeVolumeInputValue(value) {
      this.inputVolume = value;
    },
    changePipVolumeInputValue(value) {
      this.inputPipVolume = value;
    },
    initMainWindow() {
      if (!this.initOperateData) return;
      if (this.initOperateData.vfbResolution) {
        this.value = this.initOperateData.vfbResolution;
      } else {
        this.initOperateData.vfbResolution = '1280x720';
      }
      if (this.initOperateData.vfbFrameRate) {
        this.ratesValue = this.initOperateData.vfbFrameRate;
      } else {
        this.ratesValue = '30';
      }
      if (this.initOperateData.vfbBitrate) {
        this.mainWindowBitrate = this.initOperateData.vfbBitrate;
      } else {
        this.mainWindowBitrate = 400;
      }
      if (this.initOperateData.volume) {
        var _this$initOperateData;
        this.mainWindowVolume = this.initOperateData.volume;
        this.pipVolume = (_this$initOperateData = this.initOperateData.pipVolume) !== null && _this$initOperateData !== void 0 ? _this$initOperateData : 100;
        if (this.mainWindowType === 'shareScreen') {
          this.disabledMainWindowVolume = this.initOperateData.volume;
        }
      } else {
        this.mainWindowBitrate = 400;
      }
    },
    showDefault(value) {
      if (value == '30') {
        return this.$t('setting.defaultBitrate');
      } else {
        return value;
      }
    }
  }
};